import { useState, useEffect } from 'react';
import { useParams, Link } from 'react-router-dom';
import { supabase } from '../../lib/supabase';
import type { Song } from '../../types';

export default function SongDetail() {
  const { id } = useParams<{ id: string }>();
  const [song, setSong] = useState<Song | null>(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const fetchSong = async () => {
      const { data } = await supabase
        .from('songs')
        .select('*')
        .eq('id', id)
        .single();
      setSong(data);
      setLoading(false);
    };
    fetchSong();
  }, [id]);

  if (loading) {
    return (
      <div className="text-center py-8">
        <div className="animate-spin rounded-full h-8 w-8 border-4 border-primary border-t-transparent mx-auto"></div>
      </div>
    );
  }

  if (!song) {
    return (
      <div className="text-center py-8">
        <p className="text-[#8E8E93]">Canción no encontrada</p>
        <Link to="/songs" className="text-primary mt-2 block">Volver al cancionero</Link>
      </div>
    );
  }

  return (
    <div className="space-y-4">
      <Link to="/songs" className="text-primary">← Volver</Link>
      
      <div className="card p-6">
        <div className="flex items-center gap-3 mb-4">
          <h1 className="text-2xl font-bold text-white">{song.title}</h1>
          {song.key && <span className="bg-primary/10 text-primary px-3 py-1 rounded-full">{song.key}</span>}
        </div>
        
        {song.artist && <p className="text-[#8E8E93] mb-4">👤 {song.artist}</p>}

        <div className="flex gap-4 text-sm text-[#8E8E93] mb-6">
          {song.tempo && <span>⏱ {song.tempo} BPM</span>}
          <span>🎵 {song.time_signature}</span>
        </div>

        {song.lyrics && (
          <div className="mb-6">
            <h2 className="font-semibold text-[#E5E5EA] mb-2">Letra</h2>
            <pre className="whitespace-pre-wrap text-[#B3B3B3] text-sm font-mono bg-[#2C2C2E] p-4 rounded-lg">
              {song.lyrics}
            </pre>
          </div>
        )}

        {song.chords && (
          <div className="mb-6">
            <h2 className="font-semibold text-[#E5E5EA] mb-2">Acordes</h2>
            <pre className="whitespace-pre-wrap text-[#B3B3B3] text-sm font-mono bg-[#2C2C2E] p-4 rounded-lg">
              {song.chords}
            </pre>
          </div>
        )}

        {song.audio_url && (
          <audio controls className="w-full mt-4">
            <source src={song.audio_url} />
            Tu navegador no soporta audio.
          </audio>
        )}
      </div>
    </div>
  );
}
